export function formatTestId(label: string): string {
  return label?.replace(/\s+/g, "-").toLowerCase();
}
